<!-- ################################# -->
<!-- TEMPLATE -->
<!-- ################################# -->

<template>
	<div class="md-grey-page booking booking-view offers">
    <div class="container-white">
      <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-12">
        <div class="margin-top-60 text-center" v-if="isLoading || !offer">
    			<p class="mdc-theme-primary-dark loading-text">Loading<span>.</span><span>.</span><span>.</span></p>
    		</div>

        <!-- STEP 1: MAKE AN OFFER?  -->
        <div class="offers__step" v-else-if="!phase && offer.iam == 'mover'">
          <p>Dear {{ offer.applicant.fullName }}</p>
          <p>Thanks for viewing {{ offer.property.address.buildingNumber+" "+offer.property.address.street }}.</p>
          <p>Would you like to make an offer?</p>
          <div class="offers__buttons">
            <div><button href="javascript:;" class="mdc-button mdc-button--raised offers__buttons-btn" @click.prevent="doAction('asking')">Offer Asking Price</button></div>
            <div><button href="javascript:;" class="mdc-button mdc-button--raised offers__buttons-btn" @click.prevent="doAction('different')">Offer different amount</button></div>
            <div><button href="javascript:;" class="mdc-button mdc-button--raised offers__buttons-btn" @click.prevent="doAction('no')">I don’t want to offer</button></div>
            <div><button href="javascript:;" class="mdc-button mdc-button--raised offers__buttons-btn" @click.prevent="doAction('remind')">Remind me tomorrow</button></div>
            <div><button href="javascript:;" class="mdc-button offers__step__buttons-link" @click.prevent="doAction('noview')" v-if="!newoffer">I didn't view this property</button></div>
          </div>
        </div>

        <!-- WAITING APPLICANT INPUT -->
        <div class="offers__step offers__text" v-else-if="!phase && offer.iam != 'mover'">
          <p>Waiting for mover/applicant input. {{ offer.iam }}</p>
          <div class="offers__back-btn">
            <a href="/">&#60; Back to my account</a>
          </div>
        </div>

         <!-- ACCEPTED OFFER -->
        <div class="offers__step" v-else-if="phase == 'accepted'">
          Offer was agreed.
          <div v-if="offer.iam != 'mover'">
            <a :href="'/applicants/'+offer.applicant.applicantId">{{ offer.applicant.fullName }}</a> has been notified by email.
          </div>
          <div class="offers__back-btn">
            <a href="/">&#60; Back to my account</a>
          </div>
        </div>
        <div class="offers__step" v-else-if="phase == 'rejected'">
          Offer was rejected.
          <div v-if="offer.iam != 'mover'">
            <a :href="'/applicants/'+offer.applicant.applicantId">{{ offer.applicant.fullName }}</a> has been notified by email.
          </div>
          <div class="offers__back-btn">
            <a href="/">&#60; Back to my account</a>
          </div>
        </div>

        <!-- THANKS MESSAGE -->
        <div class="offers__step" v-else-if="phase == 'thanks'">
          <div class="offers__text" v-html="thanksText">
          </div>
          <div class="offers__back-btn" v-if="offer.iam != 'mover'">
            <a href="/">&#60; Back to my account</a>
          </div>
        </div>

        <!-- OFFER PRICE -->
        <div v-else-if="phase == 'price'">
          <div class="offers__property-img">
            <img :src="'https://d3acvr808w2me4.cloudfront.net/'+offer.property.mainImage" />
          </div>
          <div class="offers__property-details">
            <span class="offers__property-details--bold">{{ offer.property.address.buildingNumber + ", " + offer.property.address.street + ", " + offer.property.address.postcode }}<br></span>
            {{ offer.property.bedrooms }} Bed, {{ offer.property.type }}<br>
            Asking price of {{ formatCurrencyFull(offer.property.price) }}
          </div>

          <p class="">
            <a :href="'https://bestagent.property/p/'+offer.property.propertyId" target="_blank">View full property details ></a>
          </p>

          <div v-if="offer.iam == 'mover' && offer.nextaction == 'mover'">
            <p>Offer price of:</p>
            <editable-item component="editable-price" v-model="priceObj" title="Price"
						@isEditView="editView(arguments[0])" @update="updatedPrice" @hasErrors="errors('price', arguments[0])" :options="{}"></editable-item>

            <p>Is this correct?</p>

            <div><button href="javascript:;" class="mdc-button mdc-button--raised offers__buttons-btn" @click.prevent="sendOffer()">YES</button></div>

          </div>
          <div v-else-if="(offer.iam == 'agent' || offer.iam == 'owner') && offer.nextaction == 'agent'">
            <p>{{ offer.applicant.fullName }} has offered:</p>
            <span class="offers__offer-price">{{ formatCurrencyFull(offer.price) }}</span>
            <div class="offers__buttons">
              <div class="">
                <button href="javascript:;" class="mdc-button mdc-button--raised offers__buttons-btn" @click.prevent="acceptOffer()">Accept Offer</button>
              </div>
              <div class="">
                <button href="javascript:;" class="mdc-button mdc-button--raised offers__buttons-btn" @click.prevent="rejectOffer()">Reject Offer</button>
              </div>
            </div>
          </div>
          <div v-else>
            <span class="offers__offer-waiting">Waiting for update from the {{ offer.iam == 'mover' ? 'agent' : 'mover' }}.</span>
          </div>
        </div>

      </div>
    </div>
	</div>
</template>

<script>
import api from '@/libs/api.js';
import utils from '@/libs/mixins.js';
import EditableItem 	from '../components/editable-items/EditableItem.vue';

export default {
	data: function() {
	 return {
     offerId: undefined,
     userId: undefined,
     offer: undefined,
     phase: undefined, // pending, price, thanks
     action: undefined,
     params: undefined,
     priceObj: {
       price: 0,
       rentFrequency: 'PCM',
       newPrice: 0
     },
     newoffer: false,
     allErrors: {},
     thanksText: '',
     isLoading: true
   }
 },
 components: {
   'editable-item': EditableItem
 },
 mixins: [utils],
 created: async function() {
   this.offerId = this.$route.params.offerId;
   this.userId = this.$route.params.userId;
   this.action = this.$route.params.action;
   this.params = this.$route.params.params;

   if (!this.offerId || !this.userId) {
     window.location.pathname = '/';
     return false;
   }

   await this.getOffer();
   if (this.offer.status == 'proposed') {
     this.phase = 'price';
   }
   if (this.offer.status == 'accepted') {
     this.phase = 'accepted';
   }
   await this.doAction();
   this.isLoading = false;
 },
 methods: {
   updatedPrice() {
     this.priceObj.price = this.priceObj.newPrice;
   },
   errors: function(item, hasErrors) {
     this.allErrors[item] = hasErrors;
   },
   async doAction(action) {
     if (!action) {
       action = this.action;
     }

     if (action) {
       switch(action) {
         case "no":
          this.phase = "thanks";
          this.thanksText = `<p>Thanks for letting us know, we won’t send you any more information about this property.</p>
<p>To view our other properties please go to </p>
<a href="${offer.companyUrl ? offer.companyUrl : 'https://bestagent.property/'}" target="_blank">${offer.companyUrl ? offer.companyUrl : 'https://bestagent.property/'}</a>
`;
          break;
         case "newoffer":
          this.newoffer = true;
          break;
         case "asking":
          this.phase = "price";
          break;
         case "different":
          this.phase = "price";
          this.priceObj.price = 0;
          break;
         case "accept":
          if (this.offer.status != 'accepted' && this.offer.status != 'rejected') {
            await this.acceptOffer();
          }
          break;
         case "reject":
          if (this.offer.status != 'accepted' && this.offer.status != 'rejected') {
            await this.rejectOffer();
          }
          break;
         case "remind":
          let dtRemember = new Date();
          dtRemember.setDate(dtRemember.getDate() + 1);
          await api({endpoint: this.config.services.offers, path: '/'+this.offerId+'/'+this.userId, method: 'PUT', body: {
            status: "remember",
            remember: dtRemember.getTime(),
            nextaction: 'mover'
          }});
          this.phase = "thanks";
          this.thanksText = `Thank you, we will resend you the offer email tomorrow.`;
          break;
         case "noview":
          this.phase = "thanks";
          this.thanksText = `<p>We’ve updated our records.</p>
<p>To view our other properties please go to </p>
<a href="${offer.companyUrl ? offer.companyUrl : 'https://bestagent.property/'}" target="_blank">${offer.companyUrl ? offer.companyUrl : 'https://bestagent.property/'}</a>
`;
          break;
         default:
          console.log('Unknown action');
          this.$router.push('/offer/'+this.offerId+'/'+this.userId);
          break;
       }

     }
   },
   async sendOffer() {
     this.phase = "thanks";
     this.thanksText = `<p>Thanks for your offer of ${this.formatCurrencyFull(this.priceObj.price)} for ${this.offer.property.address.buildingNumber} ${this.offer.property.address.street}.</p>
<p>We will be in touch after we’ve contacted the owner of the property.</p>
<p>All offers are subject to contract and are not binding.</p>
`;
     await api({endpoint: this.config.services.offers, path: '/'+this.offerId+'/'+this.userId, method: 'PUT', body: {
       price: this.priceObj.price,
       remember: null,
       status: "proposed"
     }});
   },
   async acceptOffer() {
     this.phase = "accepted";
     //this.thanksText = `<a href="/applicants/${this.offerId}">${this.offer.applicant.fullName}</a> has been notified by email.`;

     await api({endpoint: this.config.services.offers, path: '/'+this.offerId+'/'+this.userId, method: 'PUT', body: {
       status: "accepted"
     }});
   },
   async rejectOffer() {
     this.phase = "rejected";
     //this.thanksText = `<a href="/applicants/${this.offerId}">${this.offer.applicant.fullName}</a> has been notified by email.`;

     await api({endpoint: this.config.services.offers, path: '/'+this.offerId+'/'+this.userId, method: 'PUT', body: {
       status: "rejected"
     }});
   },
   closeThis() {
     if (offer.iam == 'mover') {
       window.open('', '_self').close();
       window.top.close();
     } else {
       this.$router.push('/');
     }
   },
   async getOffer() {
     try {
       let offer = await api({endpoint: this.config.services.offers, path: '/'+this.offerId+'/'+this.userId, method: 'GET'});
       if (offer) {
         this.priceObj.price = offer.realPrice;
         this.offer = offer;
       } else {
         this.$router.push('/');
       }
     } catch(e) {
       //console.log('error getting offer',e.message);
       this.$router.push('/');
     }
   }
 }
}
</script>



// WEBPACK FOOTER //
// src/pages/Offer.vue